import { useFormikContext } from 'formik';
import React, { useEffect, useRef } from 'react';
import styles from './FormFields.module.scss';
import { fieldTitle } from 'pages/authenticated/settings/form-responses/factory/FormFunctions';
import renderField from './factory/renderField';
import ExpandableContainer from 'component/molecules/expandable-cont/ExpandableContainer ';

const FormFields = () => {
  const formik = useFormikContext();
  const containerRef = useRef(null);
  const lastFieldRef = useRef(null);
  const prevFieldCountRef = useRef(0);
  const prevHeightRef = useRef(0);

  const deleteInputField = (index) => {
    const updatedFields = formik.values.formDetails.filter(
      (_, i) => i !== index
    );
    formik.setFieldValue('formDetails', updatedFields);
  };

  useEffect(() => {
    const currentCount = formik.values.formDetails?.length || 0;
    const previousCount = prevFieldCountRef.current;
    const isNewFieldAdded = currentCount > previousCount;

    if (lastFieldRef.current && containerRef.current) {
      const timeout = setTimeout(() => {
        const currentHeight = lastFieldRef.current.offsetHeight;
        const previousHeight = prevHeightRef.current;

        const shouldScroll = isNewFieldAdded || currentHeight > previousHeight;

        if (shouldScroll) {
          containerRef.current.scrollTo({
            top: containerRef.current.scrollHeight,
            behavior: 'smooth',
          });
        }

        prevHeightRef.current = currentHeight;
      }, 50);

      prevFieldCountRef.current = currentCount;
      return () => clearTimeout(timeout);
    }

    prevFieldCountRef.current = currentCount;
  }, [formik.values.formDetails]);

  return (
    <div className={styles.container} ref={containerRef}>
      {formik.values.formDetails?.map((field, index) => {
        const type = field?.fieldType;
        const isLast = index === formik.values.formDetails.length - 1;

        return (
          <ExpandableContainer
            key={index}
            index={index}
            onDelete={deleteInputField}
            title={fieldTitle(type)}
            innerClassName={styles.expandableInner}
            headerClassName={styles.expandableHeader}
            accordionClassName={styles.expandableCard}
            isExpanded={true}
            ref={isLast ? lastFieldRef : null}
          >
            {renderField(type, index, field)}
          </ExpandableContainer>
        );
      })}
    </div>
  );
};

export default FormFields;
